"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnPlotAttachChanged = void 0;
/**
 * @public
 * Emitted on plot attaching or detaching from chart.
 */
class OnPlotAttachChanged {
    constructor(onPlotAttachChanged) {
        this.onPlotAttachChanged = onPlotAttachChanged;
    }
    static registerListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnPlotAttachChanged)
            .addTemporaryListener(new OnPlotAttachChanged(onEvent));
    }
    static registerOneTimeListener(plot, onEvent) {
        return plot.eventService
            .getCategory(OnPlotAttachChanged)
            .addOneTimeListener(new OnPlotAttachChanged(onEvent));
    }
    static emit(plot, chart, isAttached) {
        const listeners = plot.eventService
            .getCategory(OnPlotAttachChanged)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onPlotAttachChanged(isAttached, chart);
        }
    }
}
exports.OnPlotAttachChanged = OnPlotAttachChanged;
OnPlotAttachChanged.callbackKey = "onPlotAttachChanged";
//# sourceMappingURL=on-plot-attach-changed.js.map